import { FDCConcurrences } from '../../../cimsPage/instances/fdc'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const page = FDCConcurrences

const levels = CreateViewEditSoftRemoveRestore({
  page,
  object: 'Concurrence Level',
  view: '59b2cd75-8c43-4827-bf5b-0f9685a86174',
  create: '32eb4889-b02e-4c60-b95b-3a52c9442a2e',
  edit: '23b20b9d-34cb-420f-af57-a1213ddb5cb4',
  removeRestore: '93e3053f-0621-4ae1-8ebb-03f2dd1b5597',
})

export const ViewFDCConcurrenceLevel = levels.View
export const CreateFDCConcurrenceLevel = levels.Create
export const EditFDCConcurrenceLevel = levels.Edit
export const RemoveRestoreFDCConcurrenceLevel = levels.RemoveRestore

const groups = CreateViewEditSoftRemoveRestore({
  page,
  object: 'Concurrence Group',
  view: 'a7ff1a8a-2bd1-4038-ac10-7b305b22d4b3',
  create: '9a2c51ef-b2f2-4dc1-8041-8e0645b62b5f',
  edit: '34c9f5c2-019d-471f-98b1-b8d3910ed494',
  removeRestore: '89930309-baeb-45a8-ba7b-0f3562fb8e6a',
})

export const ViewFDCConcurrenceGroup = groups.View
export const CreateFDCConcurrenceGroup = groups.Create
export const EditFDCConcurrenceGroup = groups.Edit
export const RemoveRestoreFDCConcurrenceGroup = groups.RemoveRestore

export type FDCConcurrencePermission =
  | typeof ViewFDCConcurrenceLevel
  | typeof CreateFDCConcurrenceLevel
  | typeof EditFDCConcurrenceLevel
  | typeof ViewFDCConcurrenceGroup
  | typeof CreateFDCConcurrenceGroup
  | typeof EditFDCConcurrenceGroup
  | typeof RemoveRestoreFDCConcurrenceLevel
  | typeof RemoveRestoreFDCConcurrenceGroup
